
const getBreakpoint = function() {
	return window.getComputedStyle(document.body, ':before').content.replace(/\"/g, '');
}

window.addEventListener('resize', function () {
	breakpoint = getBreakpoint();
  console.log('Breakpoint is now:', breakpoint)
}, false);
